import { Injectable } from '@angular/core';
import LogRocket from 'logrocket';
import { ReplaySubject } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LogRocketService {
  public readySubject$ = new ReplaySubject<string>(1);
  public userName = '';
  public userId = '';

  constructor() {
    if (environment.environmentName === 'dev') {
      this.readySubject$.next('DEV');
    } else {
      LogRocket.init(environment.logRocketAppId);
      LogRocket.getSessionURL((url) => {
        this.readySubject$.next(url);
      });
    }
  }

  public identify(id: string, name: string, costCenter: string): void {
    this.userName = name;
    this.userId = id;
    LogRocket.identify(id, { name, costCenter });
  }

  public get url(): string {
    if (environment.environmentName === 'dev') return '';
    return LogRocket.sessionURL ?? '';
  }
}
